module.exports = __webpack_public_path__ + "img/enjoy.ea656e29.svg";